import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import img1Hq from "../../assets/images/Unsecured Creditor Image.png";
import img2Hq from "../../assets/images/Happy Woman Image.png";
import img3Hq from "../../assets/images/Mask Group.png";

import img1Lq from "../../assets/images/img1Lq.webp";
import img2Lq from "../../assets/images/img2Lq.webp";
import img3Lq from "../../assets/images/img3Lq.webp";

import static_img1 from "../../assets/images/building.jpg";
import static_img2 from "../../assets/images/tenant_benefits.svg";
import relworxLogo from "../../assets/idruVU2b63_logos.png";

import CustomButton from "../../components/Form/CustomButton";
import ContactUsSection from "../../components/Tenant/ContactUsSection";
import HowLandLodWorks from "../../components/Common/HowLandLodWorks";
import HeroSection from "../../components/LandLord/LandLordHeroSection";
import ReviewCardSection from "../../components/LandLord/ReviewCardSection";
import PartnersSection from "../../components/Common/PartnersSection";

const LandLodClientHome = () => {
  const [showMore, setShowMore] = useState(false);

  const features = [
    {
      title: "Analytics for Landlords",
      description:
        "Visualize rent trends, occupancy, and income — all in one dashboard.",
      imgHq: img1Hq,
      imgLq: img1Lq,
    },
    {
      title: "Secured Payment",
      description:
        "Receive instant, secure rent payments via Mobile Money and cards.",
      imgHq: img2Hq,
      imgLq: img2Lq,
    },
    {
      title: "Centralized Management",
      description:
        "Manage properties, tenants, reminders, and payouts from a single platform.",
      imgHq: img3Hq,
      imgLq: img3Lq,
    },
  ];

  return (
    <div id="home" className="px-[1.25rem] md:px-[2rem] lg:px-[0] bg-[#FBFEFF]">
      {/* Hero Section */}
      <div className="relative top-[-15px] flex justify-center w-full">
        <HeroSection />
      </div>

      {/* Information Card section */}
      <div className="flex justify-between flex-col bg-[#F6F6F6CC] w-full ">
        <div className="py-[4rem] lg:py-[6.1875rem] lg:px-[7.5rem] xl:p-[6.1875rem] ">
          <SectionTitle />
          <div className="flex flex-col xs:items-center gap-y-8 xl:flex-row xl:justify-between xl:items-start xl:gap-x-[70px] w-full">
            {features.map((item) => {
              return (
                <InfoCard
                  imgHq={item.imgHq}
                  img1Lq={item.imgLq}
                  title={item.title}
                  description={item.description}
                />
              );
            })}
          </div>
        </div>
      </div>

      {/* How landlod works */}
      <div className="my-[4rem] lg:mt-[7.5rem] lg:mb-[6.1875rem]  md:mb-[0px] flex justify-center">
        <HowLandLodWorks />
      </div>

      {/* Call to Action Section */}
      <SignUpNowCard />

      
      {/* Tenant Benefits Section */}
      <div
        className="w-11/12 xl:w-full mx-auto flex flex-col md:flex-row justify-center md:items-stretch items-start xl:px-[7.5rem] pb-14 pt-14 md:pt-10 md:pb-[0px] gap-8 md:gap-10"
      >
        <div className="flex flex-col w-full gap-8 p-0 mx-auto lg:flex-row lg:justify-center md:gap-10 lg:gap-16 md:items-stretch">
          <div className="rounded-[20px] w-full lg:w-[504px] h-[300px] sm:h-[340px] md:h-[360px] lg:h-auto  md:self-stretch overflow-hidden"   
          style={{ boxShadow: "0px 10px 15px 0px #9797971F" }}>
            <img
              src={static_img2}
              alt="About Tenafix"
              className="w-full h-full object-cover rounded-[20px]"
            />
          </div>
          {/* Tenant Benefits - Text Content */}
          <div className="flex flex-col w-full lg:w-[58%] h-full  md:p-0">
            <div className="font-alexandria font-semibold text-primary-text lg:text-4xl xl:text-[46px] lg:leading-[130%] xl:leading-[130%] lg:tracking-[0%] xl:tracking-[0%] mb-9 lg:mb-8 xl:mb-9 md:text-4xl text-[1.50rem] xs:text-[1.60rem] leading-[130%] tracking-[0%]  px-2 md:px-0 flex flex-col items-center lg:items-start xl:block">
             <div className="xl:w-[90px] xl:h-[9px] lg:w-[75px] lg:h-[8px] w-[75px] h-[8px] ml-3 lg:ml-0 xl:ml-0  mb-[16px] lg:mb-[16px] xl:mb-[16px] bg-gradient-blue" />
              <h1 className="flex flex-col items-center md:items-start ">
                <span className="block text-center">Tenant Benefits</span>
              </h1>
            </div>
            <p className="font-poppins bg-[#CFADFB1C] text-[#494949] rounded-[10px] py-6 px-6  text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px] w-full font-normal leading-[23px]  mb-4 xl:mb-4 text-justify space-y-[15px] md:leading-[23px] ">
              <span className="font-semibold font-alexandria text-primary-text text-xl block mb-3 xl:mb-[8px]">
                Fast, Simple Rent Payments
              </span>
                No accounts or sign-ups required. Tenants just enter their unique code and pay rent 
                instantly — anytime, anywhere.
            </p>
            <p className="font-poppins bg-[#CFADFB1C] text-[#494949] rounded-[10px] py-6 px-6  text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px] w-full font-normal leading-[23px]  mb-4 xl:mb-4 text-justify space-y-[15px] md:leading-[23px] ">
              <span className="font-semibold font-alexandria text-primary-text text-xl block mb-3 xl:mb-[8px]">
                Flexible Payments from Anywhere
              </span>
                Whether it's one tenant, shared rent, or support from family and friends, anyone can pay 
                directly into the landlord's account. Rent can be cleared from anywhere, anytime — with 
                ease and comfort.
            </p>            
            <p className="font-poppins bg-[#CFADFB1C] text-[#494949] rounded-[10px] py-6 px-6  text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px] w-full font-normal leading-[23px]  mb-0 xl:mb-0 text-justify space-y-[15px] md:leading-[23px] ">
              <span className="font-semibold font-alexandria text-primary-text text-xl block mb-3 xl:mb-[8px]">
                Receipts & Smart Reminders
              </span>
                Every payment comes with an instant digital receipt. Tenants also get automatic rent 
                reminders, so they never miss a due date and stay stress-free
            </p>
          </div>
        </div>
      </div>

      {/* Add Expert Services Section */}
      <div className="bg-[#F6F6F6CC]">
        <div className="w-11/12 xl:w-full mx-auto md:mb-24 md:mt-0 lg:mt-[7.5rem] mt-[4rem]  flex flex-col md:flex-row justify-center items-start gap-8 md:gap-10">
          <ExpertServicesSection />
        </div>
      </div>

      {/* About LandLod Section */}
      <div
        id="aboutus"
        className="w-11/12 xl:w-full mx-auto flex flex-col md:flex-row justify-center md:items-stretch items-start xl:px-[7.5rem] pb-14 pt-14 md:pt-0 md:pb-[120px] gap-8 md:gap-10"
      >
        <div className="flex flex-col w-full gap-8 p-0 mx-auto lg:flex-row lg:justify-center md:gap-10 md:items-stretch">
          {/* Image */}
          <div className="rounded-[20px] w-full lg:w-[594.85px] h-[300px] sm:h-[340px] md:h-[360px] lg:h-auto shadow-md md:self-stretch overflow-hidden">
            <img
              src={static_img1}
              alt="About Tenafix"
              className="w-full h-full object-cover rounded-[20px]"
            />
          </div>

          {/* AboutUs - Text Content */}
          <div className="flex flex-col w-full lg:w-[56%] h-full  md:p-0">
            {/*Divider */}
            <div className="font-alexandria font-semibold text-primary-text lg:text-4xl xl:text-[46px] lg:leading-[130%] xl:leading-[130%] lg:tracking-[0%] xl:tracking-[0%] mb-9 lg:mb-8 xl:mb-9 md:text-4xl text-[1.50rem] xs:text-[1.60rem] leading-[130%] tracking-[0%]  px-2 md:px-0 flex flex-col items-center lg:items-start xl:block">
              <div className="xl:w-[90px] xl:h-[9px] xl:ml-3 xl:mb-[23px] lg:w-[75px] lg:h-[8px] lg:ml-3 lg:mb-[20px] w-[75px] h-[8px] ml-3 mb-[35px] bg-gradient-blue" />
              <h1 className="flex flex-col items-center md:items-start ">
                <span className="block text-center">About Tenafix</span>
              </h1>
            </div>
            <p className="font-poppins text-base lg:text-base xl:text-lg w-full font-medium text-content-text  mb-5 xl:mb-6 text-justify leading-[28px] md:leading-[30px] lg:max-w-prose">
              <span className="font-semibold font-alexandria text-primary-text text-xl block mb-3 xl:mb-[8px]">
                Our Story
              </span>
              Tenafix was born out of a personal challenge faced by our founder,
              who struggled to manage his rental portfolio effectively.
              Frustrated by the inefficiencies of manual rent collection and the
              lack of real-time visibility, he developed a streamlined system to
              simplify property management. As other landlords with similar
              difficulties discovered the solution, demand grew rapidly. This
              shared need led to the creation of Tenafix, a platform dedicated
              to empowering landlords with technology that improves cash flow
              and simplifies management.
            </p>
            <p className="text-base lg:text-base xl:text-lg text-content-text w-full text-justify font-poppins font-medium leading-[28px] md:leading-[30px] lg:max-w-prose">
              <span className="font-semibold font-alexandria text-primary-text text-xl block mb-3 xl:mb-[8px]">
                Our Mission
              </span>
              Tenafix is an online rent management platform designed to simplify
              property management by eliminating manual rent collection,
              reducing delays, and providing real-time insights. Whether
              managing a single unit or multiple properties, landlords receive
              payments instantly, directly to their{" "}
              <strong>mobile money</strong>. The platform also allows landlords
              to securely upload and organize important tenant documents such as
              tenancy agreements and identification.
              {/*<ul className="pl-5 mt-4 space-y-2 list-disc">
                <li>Tenants pay securely using unique</li>
                <li>
                  system-generated codes—no registration or login required
                  {!showMore && (
                    <span
                      onClick={() => setShowMore(true)}
                      className="cursor-pointer ml-2 text-blue underline underline-offset-[3px] decoration-[2px]"
                    >
                      ...More
                    </span>
                  )}
                </li>

                {showMore && (
                  <>
                    <li>
                      Built for speed, security, and simplicity — tailored for
                      the Ugandan market
                    </li>
                    <li>
                      Fully optimized for desktop and tablet usage
                      <span
                        onClick={() => setShowMore(false)}
                        className="cursor-pointer text-blue underline underline-offset-[3px] decoration-[2px] pl-3"
                      >
                        Show less
                      </span>
                    </li>
                  </>
                )}
              </ul>*/}
            </p>
          </div>
        </div>
      </div>
      <PartnersSection
        partners={[
          {
            name: "RELWORX",
            logoSrc: relworxLogo,
            href: "https://relworx.com",
          },
        ]}
        onContactClick={() => {
          document
            .getElementById("contactus")
            ?.scrollIntoView({ behavior: "smooth" });
        }}
      />

      {/* Review Card Slider Section */}
      <div className="flex flex-col items-center justify-center">
        <div className="w-11/12 xl:w-full  xl:px-[120px] mb-[42px]">
          <h2 className="xl:text-[46px] flex sm:justify-start justify-center w-full  lg:text-4xl md:text-4xl text-[1.50rem] xs:text-[1.60rem] text-[#071952] font-semibold leading-[100%] font-alexandria  mb-[36px] sm:mb-[36px] md:mb-[40px] lg:mb-[50px] ">
            Why Landlords love Tenafix
          </h2>

          <ReviewCardSection />
        </div>
      </div>

      <JoinCommunityButton />

      {/* Contact Us Section */}
      <div
        id="contactus"
        className="flex md:justify-center md:items-center w-full py-t-[4rem] lg:py-t-[6.5rem] py-[4rem] md:pt-[120px] md:pb-[120px] xl:px-[120px] "
      >
        <ContactUsSection />
      </div>
    </div>
  );
};

export default LandLodClientHome;

export const InfoCard = ({ imgLq, imgHq, title, description }) => {
  return (
    <div className="bg-green-300 flex flex-col items-center justify-center gap-y-4 mr-0.5 xl:w-[368px] p-5 md:p-4 lg:p-0 xl-p-0">
      <LazyLoadImage
        src={imgHq}
        placeholderSrc={imgLq}
        alt="img_"
        className="object-cover rounded-[10px] w-1/3 mx-auto xl:w-full xl:h-[326px] min-w-[200px]"
        effect="blur"
        // onLoad={() => {
        //   setLoaded(true);
        // }}
        threshold={50}
      />
      <div className="flex flex-col items-center xl:items-start md:gap-y-2 lg:gap-y-5 ">
        <h1 className="font-poppins text-header-text text-center md:text-left text-[18px] font-semibold lg:font-semibold lg:text-[24px] xl:text-[28px]">
          {title}
        </h1>
        <p className="max-w-sm px-2 text-base font-medium text-center font-poppins text-content-text md:p-0 lg:text-base xl:text-lg xl:text-start sm:max-w-lg md:max-w-xl">
          {description}
        </p>
      </div>
    </div>
  );
};

export const SectionTitle = () => {
  return (
    <div
      className="font-alexandria font-semibold text-primary-text 
    lg:text-4xl lg:leading-[130%] lg:tracking-[0%] lg:mb-9
    xl:text-[46px] xl:leading-[130%] xl:tracking-[0%] xl:mb-9
    md:text-4xl text-[1.50rem] xs:text-[1.60rem] leading-[130%] tracking-[0%] mb-9 px-2 md:p-0 flex flex-col items-center xl:block"
    >
      <div
        className="xl:w-[90px] xl:h-[9px] xl:ml-3 xl:mb-[23px]
      lg:w-[75px] lg:h-[8px] lg:ml-3 lg:mb-[20px] 
      w-[75px] h-[8px] ml-3 mb-[35px] bg-gradient-blue"
      />
      <h1 className="flex flex-col items-center xl:items-start ">
        <span className="block text-center">Built for Smarter Property</span>
        <span className="block">Management</span>
      </h1>
    </div>
  );
};

export const SignUpNowCard = () => {
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    navigate("/signup");
  };

  return (
    <div className="w-11/12 xl:w-full mx-auto flex justify-center items-center px-0 md:px-0 py-2 md:py-20 xl:px-[7.5rem]">
      <div className="w-full  h-auto  p-5 xs:h-1/3 rounded-[25px] border-1 border-light-gray-custom bg-gradient-light-sky shadow-custom-grey text-center flex flex-col items-center xs:justify-around sm:px-6 md:px-16 mx-auto">
        <h2 className="font-semibold text-[1.5rem] sm:text-[2rem] md:text-[2.8125rem] leading-[2.25rem] sm:leading-[3rem] md:leading-[4.1875rem] font-alexandria text-center text-transparent bg-clip-text bg-dark-blue-text">
          Are you ready to generate reports that can{" "}
          <br className="hidden md:block" />
          be submitted to third parties like banks?
        </h2>
        <div className="mt-8">
          <CustomButton
            buttonText="Sign Up Now!"
            type="button"
            className="rounded-[5px] md:rounded-[3px] font-poppins font-semibold text-[1rem] sm:text-[1.25rem] bg-gradient-blue shadow-custom-blue text-white-text px-[0.625rem] py-[0.62rem] border-none"
            width="w-[10.5rem] sm:w-[11.75rem] xs:w-[10rem]"
            height="h-[3.5rem] sm:h-[3.875rem] xs:h-[3.2rem]"
            hoverEffect="none"
            onClick={handleSignUpClick}
          />
        </div>
      </div>
    </div>
  );
};

export const JoinCommunityButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/signup");
  };

  return (
    <div className="flex justify-center w-full items-center mt-0 md:mb-0 mb-0 ">
      {/* <button
        onClick={handleClick}
        className="font-semibold text-[1rem] sm:text-[1.5rem] md:text-[2rem] leading-[2.25rem] sm:leading-[3rem] md:leading-[4.1875rem] font-alexandria text-center text-transparent bg-clip-text bg-dark-blue-text"
      >
        Join the Tenafix Community
      </button>*/}
      <CustomButton
        buttonText="Join the Tenafix Community"
        type="button"
        className="rounded-[5px] md:rounded-[3px] font-poppins font-semibold text-[1rem] sm:text-[1.5rem] bg-gradient-blue shadow-custom-blue text-white-text px-[0.625rem] py-[0.62rem] border-none"
        width="w-[10.5rem] xs:w-[10rem] sm:w-[25rem] "
        height="h-[3.6rem] xs:h-[3.8rem] sm:h-[5rem] "
        hoverEffect="none"
        onClick={handleClick}
      />
    </div>
  );
};

const ExpertServicesSection = () => {
  return (
    <div className="px-[0rem] md:px-[0rem] lg:px-[0]  xl:px-[7.5rem] pb-14 pt-6 sm:pt-6 md:pt-16 md:pb-[64px] py-0">
      <div
        className="font-alexandria font-semibold text-primary-text  mb-10 pt-12
    lg:text-4xl lg:leading-[130%] lg:tracking-[0%] 
    xl:text-[46px] xl:leading-[130%] xl:tracking-[0%] 
    md:text-4xl text-[1.50rem] xs:text-[1.60rem] leading-[130%] tracking-[0%]  px-2 md:p-0 flex flex-col items-center xl:block"
      >
        <div
          className="xl:w-[90px] xl:h-[9px] xl:ml-3 xl:mb-[14px]
      lg:w-[75px] lg:h-[8px] lg:ml-3 lg:mb-[16px] 
      w-[75px] h-[8px] ml-3 mb-[20px] bg-gradient-blue "
        />
        <h2 className="font-alexandria flex items-start md:justify-start justify-center font-bold text-primary-text text-[1.5rem] sm:text-[2rem] md:text-[2.8125rem] leading-[2.25rem] sm:leading-[3rem] md:leading-[4.1875rem]">
          Expert Services On Demand
        </h2>
        <p className="text-[#656464] font-poppins font-medium text-[12px] xs:text-[14px] sm:text-[15px] md:text-base lg:text-lg mt-4">
          Essential landlord support, available when you need it.
        </p>
        <p className="font-poppins text-[#656464] font-medium text-[12px] xs:text-[13px] sm:text-[15px] md:text-base lg:text-lg">
          At Tenafix, we offer more than just rent collection. Landlords can
          raise a ticket directly from their dashboard, and our team routes it
          to the right department — whether it’s legal, maintenance, or
          tax-related. Each service is optional and delivered at a transparent
          fee.
        </p>
      </div>

      <div className="flex flex-col md:flex-row font-poppins text-[#494949] justify-between gap-8 lg:gap-12">
        {/* Legal Support */}
        <div className="flex flex-col items-center bg-white p-5 rounded-xl shadow-md w-full md:w-[30%]">
          <h3 className="font-semibold text-[15px] xs:text-[16px] sm:text-lg text-dark-blue-text">
            Legal Support
          </h3>
          <p className="text-[#494949] text-[12px] sm:text-[13px] md:text-[14px] lg:text-base mt-4 text-center">
            From tenancy agreements to dispute resolution, get access to
            experienced legal professionals. Raise a ticket, and we’ll connect
            you with the right expert for fast, reliable guidance.
          </p>
          {/* <div className="mt-6">
            <CustomButton
              buttonText="Raise a Ticket"
              type="button"
              className="font-poppins font-semibold text-white-text bg-gradient-blue py-2 px-4 rounded-md"
              onClick={() => console.log("Raise Legal Ticket")} // Add appropriate functionality
            />
          </div>*/}
        </div>

        {/* Property Maintenance */}
        <div className="flex flex-col items-center bg-white p-5 rounded-xl shadow-md w-full md:w-[30%]">
          <h3 className="font-semibold text-center text-[15px] xs:text-[16px] sm:text-lg text-dark-blue-text">
            Property Maintenance
          </h3>
          <p className="text-[#494949] text-[12px] sm:text-[13px] md:text-[14px] lg:text-base mt-4 text-center">
            Need a repair handled? Submit a maintenance request and we’ll
            coordinate with vetted service providers to get the job done —
            quickly and professionally.
          </p>
          {/*   <div className="mt-6">
            <CustomButton
              buttonText="Raise a Ticket"
              type="button"
              className="font-poppins font-semibold text-white-text bg-gradient-blue py-2 px-4 rounded-md"
              onClick={() => console.log("Raise Maintenance Ticket")} // Add appropriate functionality
            />
          </div>*/}
        </div>

        {/* Tax Support */}
        <div className="flex flex-col items-center bg-white p-5 rounded-xl shadow-md w-full md:w-[30%]">
          <h3 className="font-semibold text-[15px] xs:text-[16px] sm:text-lg text-dark-blue-text">
            Tax Support
          </h3>
          <p className="text-[#494949] text-[12px] sm:text-[13px] md:text-[14px] lg:text-base mt-4 text-center">
            Stay compliant with ease. Raise a tax support ticket and receive
            help with income reporting, deductions, and filing — all from
            trusted tax advisors.
          </p>
          {/*  <div className="mt-6">
            <CustomButton
              buttonText="Raise a Ticket"
              type="button"
              className="font-poppins font-semibold text-white-text bg-gradient-blue py-2 px-4 rounded-md"
              onClick={() => console.log("Raise Tax Ticket")} // Add appropriate functionality
            />
          </div>*/}
        </div>
      </div>
    </div>
  );
};
